import React from 'react'
import clsx from 'clsx';
import { ErrorMessage, FormikProps } from 'formik'
import { Attributes, Label, Validation } from 'app/modules/tp/builders/FormBuilder';
import { traverseKeyObj } from 'app/utils/keys';
import { Actions } from 'app/modules/tp/components/Modal/ModalEntity';

export type AreaInput<T> = {
    type: "textarea",
    key: keyof T,
    placeholder?: string,
    isRequired?: boolean,
    attributes?: Attributes
    rows?: number
    cols?: number
} & Attributes & Validation & Label


export type AreaInputFieldProps<T> = {
    formik: FormikProps<T>,
    inputObj: AreaInput<T>
    actions: Actions<T>,
    onChange?: (e: T) => void,
}

export const AreaInputField = <T,>({formik, inputObj, onChange}: AreaInputFieldProps<T>) => {

    const isRequiredField = (inputObj: AreaInput<T>) => {
        return inputObj.validation?.spec?.presence === 'required'
    }

    return (<>
        {inputObj.label && (
            <label className={`fw-bold fs-6 mb-2 ${isRequiredField(inputObj) ? "required" : ""} `}>
                {inputObj.label}
            </label>
        )}

        <textarea
            placeholder={`${inputObj.placeholder || ""}`}
            {...formik.getFieldProps(inputObj.key)}
            name={inputObj.key as string}
            className={clsx(
                'form-control form-control-solid mb-3 mb-lg-0',
                { 'is-invalid': formik?.touched[inputObj.key] && formik.errors[inputObj.key] },
                {
                    'is-valid': formik?.touched[inputObj.key] && !formik.errors[inputObj.key],
                }
            )}
            autoComplete='off'
            disabled={formik?.isSubmitting}
            {...inputObj.attributes}
            rows={inputObj.rows || 3}
            cols={inputObj.cols || 3}
            onChange={(e) => {
                formik.setFieldValue(inputObj.key as string, e.target.value);
                onChange && onChange(formik.values)
            }}
        >{(traverseKeyObj(formik.values, inputObj.key as string) || "") as string}</textarea>
        {formik?.touched[inputObj.key] && formik.errors[inputObj.key] && (
            <ErrorMessage name={inputObj.key as string}
                render={(error: string) => (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{error}</span>
                        </div>
                    </div>
                )} />
        )}

    </>
    )
}

export default AreaInputField;
